
export default function NotFound(){
    return <h1>404 Not Found</h1>;
}